import logo from './logo.svg';
import './App.css';
import Footer from './compoenents/Footer';
import Navbar from './compoenents/Dummy';
import Nav from './compoenents/Nav';
import Body from './compoenents/Body';
import Javascript from './compoenents/JavsScript';
import Angular from './compoenents/Angular';
import AllRoutes from './compoenents/AllRoutes';

function App() {
  return (
    <div className="App">
      <AllRoutes />
    </div>
  );
}

export default App;
